<template>
  <div class="login">
    <div class="login_left">
      <div class="content-title">
        <div class="login_left_title"></div>
        <div class="title_CN">欢迎来到热网监控管理系统</div>
        <div class="title_Eng">
          WELCOME TO HEAT NETWORK MONITORING ENTERPRISE
        </div>
      </div>
    </div>
    <div class="login_center">
      <img src="../assets/images/login-right.png" alt="" />
    </div>
    <div class="login_right">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
      >
        <div class="login-from-title">
          <div class="l1"><img src="../assets/images/l11.png" alt="" /></div>
          <div class="l2"><img src="../assets/images/l2.png" alt="" /></div>
        </div>

        <el-form-item prop="account">
          <el-input
            v-model="loginForm.account"
            type="text"
            auto-complete="off"
            placeholder="账号"
            prefix-icon="el-icon-user"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            auto-complete="off"
            placeholder="密码"
            @keyup.enter.native="handleLogin"
            prefix-icon="el-icon-warning-outline"
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="code" v-if="captchaEnabled">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
      
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img" />
        </div>
      </el-form-item> -->
        <el-checkbox
          class="rememberMe"
          v-model="rememberMe"
          style="margin: 0px 0px 25px 0px"
          >记住密码</el-checkbox
        >
        <el-form-item style="width: 100%">
          <el-button
            :loading="loading"
            size="medium"
            type="primary"
            class="addBtn"
            style="width: 100%"
            @click.native.prevent="handleLogin"
          >
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div style="float: right" v-if="register">
            <router-link class="link-type" :to="'/register'"
              >立即注册</router-link
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title">蒸汽充值管理系统</h3>
      <el-form-item prop="account">
        <el-input
          v-model="loginForm.account"
          type="text"
          auto-complete="off"
          placeholder="账号"
          prefix-icon="el-icon-user"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
          prefix-icon="el-icon-warning-outline"
        >
        </el-input>
      </el-form-item> -->
    <!-- <el-form-item prop="code" v-if="captchaEnabled">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
      
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img" />
        </div>
      </el-form-item> -->
    <!-- <el-checkbox
        v-model="loginForm.rememberMe"
        style="margin: 0px 0px 25px 0px"
        >记住密码</el-checkbox
      > -->
    <!-- <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div style="float: right" v-if="register">
          <router-link class="link-type" :to="'/register'"
            >立即注册</router-link
          >
        </div>
      </el-form-item>
    </el-form> -->
    <!--  底部  -->
    <!-- <div class="el-login-footer">
      <span>Copyright © 2018-2024 xx公司 All Rights Reserved.</span>
    </div> -->
  </div>
</template>

<script>
import { login } from "@/api/login";
// import Cookies from "js-cookie";
// import { encrypt, decrypt } from "@/utils/jsencrypt";

export default {
  name: "Login",
  data() {
    return {
      rememberMe: true,
      codeUrl: "",
      loginForm: {
        account: localStorage.getItem("userAccount") || "",
        password: localStorage.getItem("password") || "",
      },
      loginRules: {
        account: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        // password: [
        //   { required: true, trigger: "blur", message: "请输入您的密码" },
        // ],
        // code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    handleLogin() {
      console.log();
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const { data: res } = await login(this.loginForm);
          if (res.code == 1) {
            if (res.data?.oper_type == 0) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.loading = false;
              // 存储token
              sessionStorage.setItem("path", "/project");
              this.$store.commit("setUser", res.data.token);
              sessionStorage.setItem("userName", res.data.name);
              sessionStorage.setItem("account", res.data.account);
              sessionStorage.setItem("ID", res.data.role_id);
              sessionStorage.setItem("User", JSON.stringify(res.data));
              sessionStorage.setItem("real_coloums", res.data.real_coloums);
              sessionStorage.setItem("oper_type", res.data.oper_type);
              // localStorage.setItem("URL", "#/");
              if (this.rememberMe) {
                localStorage.setItem("userAccount", this.loginForm.account);
                localStorage.setItem("password", this.loginForm.password);
              } else {
                localStorage.clear("userAccount");
                localStorage.clear("password");
              }
              this.$router.push("/home");
            } else if (res.data?.oper_type == 1) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.loading = false;
              // 存储token
              sessionStorage.setItem(
                "enterprisePath",
                "/firmHome/realTimeData"
              );
              this.$store.commit("setUser", res.data.token);
              sessionStorage.setItem("userName", res.data.name);
              sessionStorage.setItem("account", res.data.account);
              sessionStorage.setItem("userID", res.data.f_id);
              sessionStorage.setItem("ID", res.data.role_id);
              sessionStorage.setItem("User", JSON.stringify(res.data));
              sessionStorage.setItem("real_coloums", res.data.real_coloums);
              sessionStorage.setItem("enterprise_id", null);
              sessionStorage.setItem("oper_type", res.data.oper_type);
              // localStorage.setItem("URL", "#/enterpriseLogin");
              if (this.rememberMe) {
                localStorage.setItem("userAccount", this.loginForm.account);
                localStorage.setItem("password", this.loginForm.password);
              } else {
                localStorage.clear("userAccount");
                localStorage.clear("password");
              }
              this.$router.push("/firmHome/realTimeData");
            } else if (res.data?.oper_type == 3) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.loading = false;
              // 存储token
              sessionStorage.setItem(
                "enterprisePath",
                "/firmHome/realTimeData"
              );
              this.$store.commit("setUser", res.data.token);
              sessionStorage.setItem("userName", res.data.name);
              sessionStorage.setItem("account", res.data.account);
              sessionStorage.setItem("userID", "");
              sessionStorage.setItem("ID", res.data.role_id);
              sessionStorage.setItem("User", JSON.stringify(res.data));
              sessionStorage.setItem("enterprise_id", res.data.f_id);
              sessionStorage.setItem("real_coloums", res.data.real_coloums);
              sessionStorage.setItem("oper_type", res.data.oper_type);
              // localStorage.setItem("URL", "#/enterpriseLogin");
              if (this.rememberMe) {
                localStorage.setItem("userAccount", this.loginForm.account);
                localStorage.setItem("password", this.loginForm.password);
              } else {
                localStorage.clear("userAccount");
                localStorage.clear("password");
              }
              this.$router.push("/firmHome/realTimeData");
            } else {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.loading = false;
              // 存储token
              sessionStorage.setItem("payPath", "/pay/index");
              this.$store.commit("setUser", res.data.token);
              sessionStorage.setItem("userName", res.data.name);
              sessionStorage.setItem("account", res.data.account);
              sessionStorage.setItem("PayProject_id", res.data.f_id);
              sessionStorage.setItem("ID", res.data.role_id);
              sessionStorage.setItem("User", JSON.stringify(res.data));
              // localStorage.setItem("URL", "#/payLogin");
              console.log(1111);
              if (this.rememberMe) {
                localStorage.setItem("userAccount", this.loginForm.account);
                localStorage.setItem("password", this.loginForm.password);
              } else {
                localStorage.clear("userAccount");
                localStorage.clear("password");
              }
              this.$router.push("/pay/index");
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.login {
  display: flex;
  // justify-content: center;
  // align-items: center;
  height: 100%;
  // background-image: url("../assets/images/login-background.jpg");
  // background-size: cover;
  .login_left {
    position: relative;
    width: 40%;
    background-size: 100% 100%;
    background-image: url("../assets/images/login-left.png");
    .content-title {
      margin-top: 20%;
      text-align: center;
      .login_left_title {
        height: 52px;
        background: url("../assets//images/login-title.png") no-repeat;
        background-position: 50%;
        background-size: 380px 100px;
        margin-bottom: 22px;
      }
      .title_CN {
        font-size: 24px;
        color: #fff;
        line-height: 56px;
        letter-spacing: 1px;
        text-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
      }
      .title_Eng {
        font-size: 16px;
        letter-spacing: 2px;
        color: #fff;
      }
    }
  }
  .login_center {
    height: 166px;
    width: 166px;
    position: absolute;
    top: 50%;
    margin-top: -83px;
    left: 35.7%;
    background-size: 166px 166px;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login_right {
    position: relative;
    width: 60%;
  }
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .login-from-title {
    display: flex;
    align-items: flex-end;
    margin-bottom: 30px;
    .l1 {
      margin-right: 20px;
      width: 108px;
      height: 47px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .l2 {
      width: 154px;
      height: 29px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
::v-deep .el-input {
  height: 48px;
  input {
    height: 48px;
  }
}
::v-deep .input-icon {
  height: 39px;
  width: 14px;
  margin-left: 2px;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  position: absolute;
  bottom: 0;
  height: 40px;
  line-height: 40px;
  position: fixed;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
.el-button--medium {
  height: 50px;
}
</style>
